<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <form @submit.prevent="login" class="has-text-centered">
          <b-loading
            :is-full-page="true"
            :active="isLoading"
            :can-cancel="false"
          ></b-loading>

          <div class="columns">
            <div class="column"></div>
            <div class="column is-half has-text-centered">
              <img
                src="../../assets/img/logo-smart-orange-outline.png"
                width="170"
                height="22"
                alt="Logo Onii"
                class="is-block mx-auto"
                title="Onii"
              />

              <h1 class="is-size-3 has-text-weight-semibold">Parceiro</h1>
              <br />

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="email"
                  class="is-expanded"
                  type="email"
                  placeholder="E-mail"
                ></b-input>
              </b-field>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="password"
                  class="is-expanded"
                  type="password"
                  placeholder="Senha"
                  password-reveal
                ></b-input>
              </b-field>

              <router-link to="forgot-password">
                <h3 class="is-size-6 has-text-deep-purple has-text-left">
                  Esqueci minha senha
                </h3>
              </router-link>
              <br />

              <button
                class="button is-primary is-medium is-fullwidth has-text-weight-bold"
              >
                Entrar
              </button>
            </div>
            <div class="column"></div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common.js";

export default {
  mixins: [common],

  data() {
    return {
      email: "",
      password: "",
      isLoading: false
    };
  },

  methods: {
    login() {
      this.isLoading = true;
      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$router.push("dashboard");
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
